import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const AWSElasticsearchReader5xForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;
  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="awsElasticsearchReader5xFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={form.formState.errors.name?.message}
      />
      <FormField
        controlId="awsElasticsearchReader5xFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={form.formState.errors.type?.message}
      />
      <FormField
        controlId="awsElasticsearchReader5xFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="awsElasticsearchReader5xFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.parameterizedBy?.message}
      />
      <FormField
        controlId="awsElasticsearchReader5xFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="awsElasticsearchReader5xFormIndex"
        label="index"
        name="properties.index"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter index"
        required
        error={form.formState.errors.properties?.index?.message}
      />
      <FormField
        controlId="awsElasticsearchReader5xFormAwsKey"
        label="awsKey"
        name="properties.awsKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter AWS key"
        error={errors?.properties?.awsKey?.message}
      />
      <FormField
        controlId="awsElasticsearchReader5xFormAwsSecret"
        label="awsSecret"
        name="properties.awsSecret"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="password"
        placeholder="Enter AWS secret"
        error={errors?.properties?.awsSecret?.message}
      />
      <FormField
        controlId="awsElasticsearchReader5xFormAwsRegion"
        label="awsRegion"
        name="properties.awsRegion"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter AWS region"
        error={errors?.properties?.awsRegion?.message}
      />
      <FormField
        controlId="awsElasticsearchReader5xFormScroll"
        label="scroll"
        name="properties.scroll"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors?.properties?.scroll?.message}
      />
      <FormField
        controlId="awsElasticsearchReader5xFormElasticsearchEndpoint"
        label="elasticsearchEndpoint"
        name="properties.elasticsearchEndpoint"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Elasticsearch endpoint"
        error={errors?.properties?.elasticsearchEndpoint?.message}
      />
      <FormField
        controlId="awsElasticsearchReader5xFormQuery"
        label="query"
        name="properties.query"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        placeholder="Enter query"
        required
        error={form.formState.errors.properties?.query?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default AWSElasticsearchReader5xForm;
